<template>
  <div class="base-report report-sales-item">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.method" size="mini" >
          <el-option
            v-for="item in methods"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select class="mode" v-show="isShowMode" v-model="searchForm.mode" size="mini" >
          <el-option
            v-for="item in modes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          height="100%"
          @sort-change="sortTable"
          :row-class-name="getRowClass">
          <template v-for="(header, index) in tableSetting">
            <template v-if="header.prop === 'date' && currentMethod === methodType.daily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    {{ scope.row.date|date }}
                    <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="header.prop === 'date' && currentMethod === methodType.weekdaily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    <span class="w" :class="weekdayClassByWeekdayName(scope.row.weekdayName)">{{ scope.row.weekdayName }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subheader.prop + subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    align="right"
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'

export default {
  name: 'ReportSalesItem',
  data () {
    const methodType = {
      daily: 1,
      monthly: 2,
      weekdaily: 3,
      hourly: 4,
      orderHourly: 5,
    }
    const targetType = {
      item: 1,
      payment: 2,
      category: 3,
    }
    const modeType = {
      item: 1,
      department: 2,
      category: 3,
    }

    return {
      ratioStr: null,
      isLoading: false,
      noData: false,
      methodType: {...methodType},
      modeType: {...modeType},
      methods: [{value: methodType.daily, label: '日毎'}, {value: methodType.monthly, label: '月毎'}, {value: methodType.weekdaily, label: '曜日毎'}, {value: methodType.hourly, label: '時間毎'}, {value: methodType.orderHourly, label: '時間（注文時）毎'}],
      modes: [{value: modeType.item, label: '商品'}, {value: modeType.department, label: '部門'}, {value: modeType.category, label: 'グループ'}],
      isShowMode: true,
      tableSetting: [
        {label: '年月日', prop: 'date', align: 'center', fixed: true, width: '130px'},
        {label: 'コード', prop: 'itemCode', align: 'center', sortable: 'custom', width: '100px'},
        {label: '商品名', prop: 'itemName', align: 'left', sortable: 'custom', width: '160px'},
        {label: '単価', prop: 'unitPrice', align: 'right', sortable: 'custom', width: '100px'},
        {label: '売上', prop: 'itemTotalPrice', align: 'right', sortable: 'custom', width: '120px'},
        {label: '売上(税抜)', prop: 'itemExcludeTaxTotalPrice', align: 'right', sortable: 'custom', width: '120px'},
        {label: '個数', prop: 'itemCount', align: 'right', sortable: 'custom', width: '100px'},
        {label: '原価', prop: 'itemCostPrice', align: 'right', sortable: 'custom', width: '100px'},
        {label: '粗利益', prop: 'grossProfit', align: 'right', sortable: 'custom', width: '100px'},
        {label: 'オプション', prop: 'optionTotalPrice', align: 'right', sortable: 'custom', width: '120px'},
        {label: 'OP数', prop: 'optionCount', align: 'right', sortable: 'custom', width: '100px'},
        {label: '売上順位', prop: 'salesRanking', align: 'right', sortable: 'custom', width: '120px'},
        {label: '売上比率', prop: 'salesRatio', align: 'right', sortable: 'custom', width: '120px'},
        {label: '個数順位', prop: 'countRanking', align: 'right', sortable: 'custom', width: '120px'},
        {label: '個数比率', prop: 'countRatio', align: 'right', sortable: 'custom', width: '120px'},
      ],
      searchForm: {
        target: targetType.item,
        method: methodType.daily,
        mode: modeType.item,
        from_date: null,
        to_date: null,
      },
      items: [],
      groupData: {},
      currentMethod: methodType.daily,
      currentMode: modeType.item,
      orgData: [],
      totalData: [],
      form: {},
      csv_filename: '売上詳細.csv',
    }
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  computed: {
    ...mapGetters('holiday', ['holidays']),
    ...mapGetters('report', ['ratioStrFunction']),
    screenData () {
      let result = []
      let blockData = []
      for (let data of this.orgData) {
        this.calcDateValue(data.data)
        blockData.push(data)
        if (data.type === 'subtotal') {
          let dataGrouped = this.calcGroupItemData(blockData)
          result.push(...dataGrouped)
          blockData = []
        }
      }
      return result
    },
  },
  created () {
    this.ratioStr = this.ratioStrFunction
  },
  mounted () {
    this.getHolidays()
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.items = []
      this.totalData = []
      this.orgData = []
      this.currentMethod = this.searchForm.method
      this.currentMode = this.searchForm.mode

      this.$request.reports.details(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.method, this.searchForm.target, this.searchForm.mode).then(res => {
        this.items = res.body
        this.tableSetting[0].label = this.getDateStr()
        if (this.items) {
          for (let record of this.items.records) {
            this.orgData.push(record)
          }
        }

        // get groups data
        if (this.items.groups) {
          for (let group of this.items.groups) {
            this.groupData[group.key] = group
          }
        }
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    calcGroupItemData: function (data) {
      let result = []
      switch (this.currentMode) {
        case this.modeType.item:
          for (let record of data) {
            if (record.type === 'subtotal') {
              record.data.itemName = '【合計】'
            }
            result.push(record.data)
          }
          break
        case this.modeType.department:
        case this.modeType.category:
          result = this.groupItemData(data)
          break
      }
      return result
    },
    groupItemData: function (data) {
      let result = []

      // group
      let listGroup = this.calcGroupData(data)

      for (let group of this.items.groups) {
        result.push(...this.updateItemGroup(group.key, listGroup))
        delete listGroup[group.groupKey]
      }
      result.push(...this.updateItemGroup('otherGroup', listGroup))

      // push total
      result.push(listGroup['subtotal'])
      return result
    },
    calcGroupData: function (data) {
      let groupData = this.groupData
      let listGroup = {}

      for (let obj of data) {
        this.calcDateValue(obj.data)
        if (obj.type === 'subtotal') {
          obj.data.itemName = obj.data.categoryName = '【合計】'
          obj.data.isSubTotal = true
          listGroup['subtotal'] = obj.data
          continue
        }

        let key = obj.data.groupKey

        if (groupData[key] === undefined) {
          key = 'otherGroup'
        }

        if (listGroup[key] === undefined) {
          listGroup[key] = []
        }
        listGroup[key].push(obj.data)
      }

      return listGroup
    },
    updateItemGroup: function (group, listGroup) {
      let result = []

      if (!listGroup[group]) {
        return result
      }

      let totalGroup = {
        isTotal: true,
        itemName: '',
        date: 0,
        hour: 0,
        grossProfit: 0,
        itemCostPrice: 0,
        itemExcludeTaxTotalPrice: 0,
        itemTotalPrice: 0,
        optionTotalPrice: 0,
        optionCount: 0,
        itemCount: 0,
      }

      // get group name
      let name = ''
      if (group === 'otherGroup') {
        name = 'その他'
      } else {
        let groupRecord = this.groupData[group]
        name = groupRecord.name
      }
      totalGroup.itemName = `【${name}】`

      for (let row of listGroup[group]) {
        totalGroup.date = row.date
        totalGroup.hour = row.hour
        totalGroup.weekdayName = row.weekdayName
        totalGroup.grossProfit += parseFloat(row.grossProfit)
        totalGroup.itemCostPrice += parseFloat(row.itemCostPrice)
        totalGroup.itemExcludeTaxTotalPrice += parseFloat(row.itemExcludeTaxTotalPrice)
        totalGroup.itemTotalPrice += parseFloat(row.itemTotalPrice)
        totalGroup.optionTotalPrice += parseFloat(row.optionTotalPrice)
        totalGroup.optionCount += row.optionCount
        totalGroup.itemCount += parseFloat(row.itemCount)
        result.push(row)
      }

      result.push(totalGroup)
      return result
    },
    sortTable ({column, prop, order}) {
      if (!prop) {
        this.orgData = []
        this.orgData.push(...this.items.records)
        return
      }

      let direction = order === 'ascending' ? 1 : -1
      this.orgData.sort((a, b) => {
        let dataA = a.data
        let dataB = b.data
        let momentA = moment(dataA.date)
        let momentB = moment(dataB.date)
        if (momentA.isAfter(momentB)) {
          return 1
        } else if (momentA.isBefore(momentB)) {
          return -1
        } else {
          if (a.type === 'subtotal') {
            return 1
          } else if (b.type === 'subtotal') {
            return -1
          } else {
            let valueA = dataA[prop]
            let valueB = dataB[prop]
            if (!valueA && !valueB) {
              return 0
            } else if (!valueA) {
              valueA = (typeof valueB === 'string') ? '' : 0
            } else if (!valueB) {
              valueB = (typeof valueA === 'string') ? '' : 0
            }
            let sort = (typeof valueA === 'string') ? valueA.localeCompare(valueB) : valueA - valueB
            return direction * sort
          }
        }
      })
    },
    getRowClass ({row, rowIndex}) {
      if (row.isTotal) {
        return 'row-total'
      } else if (row.isSubTotal) {
        return 'row-subtotal'
      }
      return 'row-data'
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    date (value) {
      let result = '-'
      switch (this.currentMethod) {
        case this.methodType.daily:
          let date = moment(value).format('YYYY/MM/DD')
          let day = moment(value).locale('ja').format('ddd')
          result = date + '(' + day + ')'
          break
        case this.methodType.monthly:
          result = moment(value).format('YYYY年MM月')
          break
        case this.methodType.weekdaily:
          result = value
          break
        case this.methodType.hourly:
          result = value + ':00〜' + value + ':59'
          break
        case this.methodType.orderHourly:
          result = value + ':00〜' + value + ':59'
          break
      }
      return result
    },
    getDateStr () {
      switch (this.currentMethod) {
        case this.methodType.daily:
          return '年月日'
        case this.methodType.monthly:
          return '年月'
        case this.methodType.weekdaily:
          return '曜日'
        case this.methodType.hourly:
          return '時間'
        case this.methodType.orderHourly:
          return '時間'
      }
    },
    calcDateValue (record) {
      switch (this.currentMethod) {
        case this.methodType.daily:
          record.date = record.date
          break
        case this.methodType.monthly:
          record.date = record.date
          break
        case this.methodType.weekdaily:
          record.date = record.weekdayName
          break
        case this.methodType.hourly:
          record.date = record.hour
          break
        case this.methodType.orderHourly:
          record.date = record.hour
          break
      }
    },
    getGroupLabelStr () {
      switch (this.currentMode) {
        case this.modeType.department:
          return '部門'
        case this.modeType.category:
          return 'グループ'
      }
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      switch (key) {
        case 'date':
          return this.date(value)
        case 'code':
          return value
        case 'name':
          return value
        case 'itemCode':
          return value
        case 'itemName':
          return value
        case 'salesRatio':
          return this.ratioStr(value)
        case 'countRatio':
          return this.ratioStr(value)
        case 'categoryCode':
          return value
        case 'categoryName':
          return value
        default:
          return addFigure(parseInt(value))
      }
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    printWeekday (item) {
      if (this.isHoliday(item.date)) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (this.isHoliday(item.date)) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (ret !== 'sun' && this.isHoliday(item.date, true)) {
        return 'bho'
      }
      return ret
    },
    weekdayClassByWeekdayName (name) {
      if (name === '日') {
        return 'sun'
      } else if (name === '土') {
        return 'sat'
      } else if (name === '祝') {
        return 'hol'
      }
    },
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>

<style scoped>
div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportSalesItem.vue